import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ArrowLeftIcon, TargetIcon, BarChartIcon, LightbulbIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const TeamLid1Page: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2180">
      <SEO data-id="element-2181" />
      <Header data-id="element-2182" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2183">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2184">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2185">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2186" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2187">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2188">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] overflow-hidden shadow-lg" data-id="element-2189">
                <img src="https://cdn.magicpatterns.com/uploads/6NEVZ9gbtbKb9LzgRcu9P4/image.png" alt="Rocco" className="w-full h-full object-cover" style={{
                objectPosition: 'center 35%'
              }} data-id="element-2190" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2191">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2192">
                Rocco
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2193">
                Oprichter & Strateeg
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2194">
                <p className="mb-4" data-id="element-2195">
                  Als oprichter van Noord Digital en bedenker van de CorePrint
                  methode, ben ik dagelijks bezig met het vertalen van complexe
                  bedrijfsdoelstellingen naar meetbare online strategieën. Mijn
                  passie ligt op het snijvlak van data, psychologie en
                  technologie.
                </p>
                <p className="mb-4" data-id="element-2196">
                  Voordat ik Noord Digital startte, zag ik te vaak dat bedrijven
                  investeerden in marketing zonder duidelijk plan of meetbaar
                  resultaat. Dat moest anders. Met CorePrint hebben we een
                  fundament gebouwd dat groei voorspelbaar maakt.
                </p>
                <p data-id="element-2197">
                  In mijn werk focus ik me op de grote lijnen: waar liggen de
                  kansen in de markt, hoe positioneren we onze klanten het
                  sterkst, en welke kanalen leveren de hoogste ROI op. Ik geloof
                  heilig dat elke beslissing onderbouwd moet worden met data,
                  niet met onderbuikgevoel.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2198">
                Expertise
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2199">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2200">
                  <LightbulbIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2201" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2202">Strategy</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2203">
                  <TargetIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2204" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2205">CorePrint</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2206">
                  <BarChartIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2207" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2208">Data-analyse</h3>
                </div>
              </div>

              <a href="/#contact" className="inline-block bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2209">
                Neem contact op met Rocco
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2210" />
    </div>;
};